/**
 * Land on the thread a first message just opened (spec 2026-09-18-03 § 5).
 *
 * The current history entry is REPLACED, not pushed: a reload must land in the
 * real `/c/` thread, and the back button must not return the resident to the
 * door they came through, which no longer holds anything of theirs.
 *
 * Only the path of the server-built URL is used. The server mints it from
 * `server.base_url`, which on a misconfigured stack names a DIFFERENT host than
 * the one the resident is reading — the trap documented in
 * docs/testing/e2e-ci-equivalent.md, where the browser crosses into another database mid-flow and the
 * thread it just created is genuinely not there. The token is valid on the
 * server that issued it, and that is the server this page is talking to.
 */
export function enterConversation(conversationUrl: string): boolean {
    if (!conversationUrl) return false
    try {
        const url = new URL(conversationUrl, window.location.origin)
        window.location.replace(`${url.pathname}${url.search}`)

        return true
    } catch {
        return false
    }
}
